// extracted by mini-css-extract-plugin
export default {"favoriteLink":"ToolBar_favoriteLink__lsXAa","counter":"ToolBar_counter__pxGsi"};